import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api, { apiErrorMessage } from "@/lib/api";
import { ResourcePanel } from "./ResourcePanel";
import { ConnectionsTable } from "./ConnectionsTable";
import { ProviderDrawer } from "./ProviderDrawer";

function AddProvider({ open, setOpen, onSaved }) {
  const [name, setName] = useState("");
  const [purpose, setPurpose] = useState("");
  const save = async () => {
    try { await api.post("/admin/software/providers", { name, purpose, status: "unknown", cost_source: "manual" }); toast.success("Added"); setOpen(false); setName(""); setPurpose(""); onSaved(); }
    catch (e) { toast.error(apiErrorMessage(e, "Could not add")); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md" data-testid="add-provider-dialog">
        <DialogHeader><DialogTitle>Add a software connection</DialogTitle></DialogHeader>
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" data-testid="add-provider-name" />
        <Input value={purpose} onChange={(e) => setPurpose(e.target.value)} placeholder="What Strata uses it for" data-testid="add-provider-purpose" />
        <DialogFooter><Button disabled={!name} onClick={save} className="bg-[#327de3] text-white hover:bg-[#1f64c2]" data-testid="add-provider-save">Add</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function SoftwareConnectionsPanel() {
  const [data, setData] = useState(null);
  const [runbooks, setRunbooks] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [adding, setAdding] = useState(false);
  const load = useCallback(async () => {
    try {
      const [p, r] = await Promise.all([api.get("/admin/software/providers"), api.get("/admin/software/runbooks")]);
      setData(p.data); setRunbooks(r.data);
    } catch (e) { toast.error(apiErrorMessage(e, "Could not load connections")); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const open = data?.providers.find((x) => x.id === openId) || null;
  const checkLinks = async () => { try { await api.post("/admin/software/providers/check-links"); toast.success("Links checked"); load(); } catch (e) { toast.error(apiErrorMessage(e, "Link check failed")); } };
  return (
    <div className="space-y-4" data-testid="software-connections-panel">
      <ResourcePanel />
      <div className="flex items-center justify-between">
        <div><div className="text-base font-bold text-slate-900">Software connections</div><div className="text-xs text-slate-500">Click a row for details, setup history and edits. Every amount shows where it came from.</div></div>
        <button onClick={checkLinks} className="text-xs text-[#327de3] font-semibold hover:underline" data-testid="connections-check-links">Check management links</button>
      </div>
      <ConnectionsTable data={data} onOpen={(p) => setOpenId(p.id)} onAdd={() => setAdding(true)} />
      <ProviderDrawer p={open} cards={data?.cards || []} runbooks={runbooks} onClose={() => setOpenId(null)} onSaved={load} />
      <AddProvider open={adding} setOpen={setAdding} onSaved={load} />
    </div>
  );
}
